import { HTMLAttributes } from 'react';

export default function InputError({ message, className = '', ...props }: HTMLAttributes<HTMLParagraphElement> & { message?: string }) {
    return message ? (
        <p {...props} className={'text-[12px] text-crimsonAlert mt-1 ' + className}>
            {message}
        </p>
    ) : null;
}
